import React from "react";

type CheckboxProps = {
  id: string;
  label: string | React.ReactNode;
  description?: string;
  checked: boolean;
  setChecked: (isChecked: boolean) => void;
  disabled?: boolean;
  className?: string;
};
const Checkbox = ({ id, label, description, checked, setChecked, disabled, className = "" }: CheckboxProps) => {
  return (
    <div className={`relative flex items-start ${className}`}>
      <div className="flex h-5 items-center cursor-pointer">
        <input
          checked={checked}
          disabled={disabled}
          id={id}
          aria-describedby={`${id}-description`}
          name={id}
          type="checkbox"
          className={`h-4 w-4 rounded border-gray-300 ${
            disabled ? "text-gray-300" : "cursor-pointer text-emerald-600 focus:ring-emerald-500"
          }`}
          onChange={(e) => setChecked(e.target.checked)}
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className={`font-medium  ${disabled ? "text-gray-400" : "text-gray-700 cursor-pointer"}`}>
          {label}
        </label>
        {description && (
          <p id={`${id}-description`} className={disabled ? "text-gray-300" : "text-gray-500"}>
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
